// extracted by mini-css-extract-plugin
module.exports = {"ratingWrp":"slider_ratingWrp__1ykfk","ratingTextWrp":"slider_ratingTextWrp__V7gzg","ratingLabel":"slider_ratingLabel__1AMZJ"};